import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  ReportTable,
  InputTitle,
  InputText,
  Tr,
  Td,
  ReportTableLabel,
} from './styles/EditAreaStyles';
import Calendar from '../Calendar';

/**
 * Web報告書作成・編集エリアのコンポーネント
 * @component
 */
const EditArea = ({
  reportNo,
  subject,
  createDate,
  author,
  onChangeCreateDate,
  onChangeSubject,
}) => (
  <ReportTable>
    <tbody>
      <Tr>
        <th>
          <InputTitle>
            <FormattedMessage id="report.edit.info.number" />
          </InputTitle>
        </th>
        <Td colSpan="3">
          <ReportTableLabel>{reportNo}</ReportTableLabel>
        </Td>
      </Tr>
      <Tr>
        <th>
          <FormattedMessage id="report.edit.info.subject" />
        </th>
        <Td colSpan="3">
          <InputText
            id="edit-report-subject"
            type="text"
            value={subject}
            width="450px"
            onInput={e => onChangeSubject(e.target.value)}
            maxLength={32}
          />
        </Td>
      </Tr>
      <Tr>
        <th>
          <FormattedMessage id="report.edit.info.creationDate" />
        </th>
        <Td width="294">
          <Calendar
            id="edit-report-created-at"
            value={createDate}
            hideTime
            height={23}
            onSearch={value => onChangeCreateDate(value)}
          />
        </Td>
        <th>
          <FormattedMessage id="report.edit.info.author" />
        </th>
        <Td>
          <ReportTableLabel>{author}</ReportTableLabel>
        </Td>
      </Tr>
    </tbody>
  </ReportTable>
);

EditArea.propTypes = {
  reportNo: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  createDate: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  onChangeSubject: PropTypes.func.isRequired,
  onChangeCreateDate: PropTypes.func.isRequired,
};

export default EditArea;
